import React, {Component} from 'react'

class McpIntegrations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIntegration: 'claude'
        };
    }

    handleIntegrationClick = (integration) => {
        this.setState({ selectedIntegration: integration });
    };

    getInstructions = (integration) => {
        const instructions = {
            claude: {
                title: "Claude Desktop App",
                steps: [
                    "Open the Claude Desktop App",
                    "Click on your profile, then go to Settings",
                    "Click on Connectors in Settings",
                    "Click on 'Add Custom Connector'",
                    "Paste in the MCP URL and click 'Add'",
                    "Make sure the tool is enabled and start chatting!"
                ]
            },
            // openai: {
            //     title: "OpenAI Integration",
            //     steps: [
            //         "Navigate to your OpenAI platform settings",
            //         "Go to the MCP (Model Context Protocol) section",
            //         "Click Add new MCP server",
            //         "Enter the server configuration details",
            //         "Save and test the connection"
            //     ]
            // },
            cursor: {
                title: "Cursor IDE",
                steps: [
                    "Navigate to Settings, then Cursor Settings",
                    "Select MCP on the left",
                    "Click Add new global MCP server at the top right",
                    "Copy and paste the server config to your existing file, then save"
                ]
            }
        };
        return instructions[integration] || null;
    };

    render() {
        const { selectedIntegration } = this.state;
        const instructions = selectedIntegration ? this.getInstructions(selectedIntegration) : null;

        return (
            <div>
                <div style={{ 
                    display: "flex", 
                    gap: "12px", 
                    marginBottom: "16px",
                    marginTop: "16px",
                    flexWrap: "wrap"
                }}>
                    <button
                        onClick={() => this.handleIntegrationClick('claude')}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            padding: "12px 16px",
                            border: "1px solid #F0F0F0",
                            borderRadius: "4px",
                            backgroundColor: selectedIntegration === 'claude' ? "#F0F0F0" : "white",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#333",
                            transition: "all 0.2s ease",
                            outline: "none"
                        }}
                        onMouseEnter={(e) => {
                            if (selectedIntegration !== 'claude') {
                                e.target.style.backgroundColor = "#f9f9f9";
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (selectedIntegration !== 'claude') {
                                e.target.style.backgroundColor = "white";
                            }
                        }}
                    >
                        <div style={{
                            width: "20px",
                            height: "20px",
                            backgroundColor: "#333",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "bold"
                        }}>
                            A
                        </div>
                        Claude
                    </button>

                    {/*<button*/}
                    {/*    onClick={() => this.handleIntegrationClick('openai')}*/}
                    {/*    style={{*/}
                    {/*        display: "flex",*/}
                    {/*        alignItems: "center",*/}
                    {/*        gap: "8px",*/}
                    {/*        padding: "12px 16px",*/}
                    {/*        border: "1px solid #F0F0F0",*/}
                    {/*        borderRadius: "4px",*/}
                    {/*        backgroundColor: selectedIntegration === 'openai' ? "#F0F0F0" : "white",*/}
                    {/*        cursor: "pointer",*/}
                    {/*        fontSize: "14px",*/}
                    {/*        fontWeight: "500",*/}
                    {/*        color: "#333",*/}
                    {/*        transition: "all 0.2s ease",*/}
                    {/*        outline: "none"*/}
                    {/*    }}*/}
                    {/*    onMouseEnter={(e) => {*/}
                    {/*        if (selectedIntegration !== 'openai') {*/}
                    {/*            e.target.style.backgroundColor = "#f9f9f9";*/}
                    {/*        }*/}
                    {/*    }}*/}
                    {/*    onMouseLeave={(e) => {*/}
                    {/*        if (selectedIntegration !== 'openai') {*/}
                    {/*            e.target.style.backgroundColor = "white";*/}
                    {/*        }*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    <div style={{*/}
                    {/*        width: "20px",*/}
                    {/*        height: "20px",*/}
                    {/*        backgroundColor: "#333",*/}
                    {/*        borderRadius: "50%",*/}
                    {/*        display: "flex",*/}
                    {/*        alignItems: "center",*/}
                    {/*        justifyContent: "center",*/}
                    {/*        color: "white",*/}
                    {/*        fontSize: "10px"*/}
                    {/*    }}>*/}
                    {/*        ⚡*/}
                    {/*    </div>*/}
                    {/*    OpenAI*/}
                    {/*</button>*/}

                    <button
                        onClick={() => this.handleIntegrationClick('cursor')}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            padding: "12px 16px",
                            border: "1px solid #F0F0F0",
                            borderRadius: "4px",
                            backgroundColor: selectedIntegration === 'cursor' ? "#F0F0F0" : "white",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#333",
                            transition: "all 0.2s ease",
                            outline: "none"
                        }}
                        onMouseEnter={(e) => {
                            if (selectedIntegration !== 'cursor') {
                                e.target.style.backgroundColor = "#f9f9f9";
                            }
                        }}
                        onMouseLeave={(e) => {
                            if (selectedIntegration !== 'cursor') {
                                e.target.style.backgroundColor = "white";
                            }
                        }}
                    >
                        <div style={{
                            width: "20px",
                            height: "20px",
                            backgroundColor: "#333",
                            borderRadius: "4px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "white",
                            fontSize: "12px"
                        }}>
                            ◇
                        </div>
                        Cursor
                    </button>
                </div>

                {instructions && (
                    <div style={{
                        backgroundColor: "#f8f9fa",
                        border: "1px solid #F0F0F0",
                        borderRadius: "4px",
                        padding: "20px",
                        marginTop: "16px",
                        marginBottom: "16px"
                    }}>
                        <h3 style={{
                            margin: "0 0 16px 0",
                            fontSize: "18px",
                            fontWeight: "600",
                            color: "#333"
                        }}>
                            {instructions.title}
                        </h3>
                        <ol style={{
                            margin: "0",
                            paddingLeft: "20px",
                            color: "#555",
                            lineHeight: "1.6"
                        }}>
                            {instructions.steps.map((step, index) => (
                                <li key={index} style={{ marginBottom: "8px" }}>
                                    {step}
                                </li>
                            ))}
                        </ol>
                    </div>
                )}
            </div>
        );
    }
}

export default McpIntegrations;
